/**
 * @description Функция для разделения фразы на две строки
 */
export function splitPhraseIntoTwoLines(phrase) {
  const words = phrase.split(' '); // Разделяем фразу на слова

  const totalLength = phrase.length;
  let currentLength = 0;
  let splitIndex = 0;
  while (splitIndex < words.length) {
    const word = words[splitIndex];
    if (currentLength + word.length + 1 <= totalLength / 2) {
      currentLength += word.length + 1; // Учитываем пробел

      splitIndex++;
    } else {
      break;
    }
  }
  return [words.slice(0, splitIndex).join(' '), words.slice(splitIndex).join(' ')];
}